import Vue from 'vue';

Vue.filter('UpperCase', (value) => {
    if (!value) return '';
    return value.toUpperCase();
});
